import { Text } from '@wix/design-system';
import React from 'react';
import { RuleTipBox } from '../../../rule-layout/rule-tip/rule-tip-box';
import { RuleTipItem } from '../../../rule-layout/rule-tip/rule-tip-item';
export const HelperTip = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(RuleTipBox, {
    dataHook: "helper-tip-container",
    marginTop: "SP1"
  }, /*#__PURE__*/React.createElement(RuleTipItem, {
    dataHook: "helper-tip-text",
    showIcon: false
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "helper-tip-text",
    size: "tiny",
    weight: "thin",
    secondary: true
  }, children)));
};
//# sourceMappingURL=helper-tip.js.map